<template>
    <div>
        <div v-for="(router , key) in getList()" :key="router.path">        
        <li :key="router.path" @click="pageChange($event)">
        <router-link v-if="router.children === undefined" :key="router.path" :active-class="'current-title'" :to="showClass === 'headerlink' ? strMainPath + '/' + router.currentKey : router.path">{{router.name}}</router-link>
        <a v-else :href="'#subTitle'+key" data-toggle="collapse" :aria-expanded="expanded(router.children,strurl)" aria-controls="collapseMenu">{{router.name}} <i class="fas fa-chevron-up"></i><i class="fas fa-chevron-down"></i></a>        
        </li>    
        <div v-if="router.children !== undefined" v-html="menuBind(router, key)"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'menulist',
  data () {    
    return {
      strMainPath: '',
      showClass: '',
      strurl: window.location.pathname
    }
  },
  methods:{
    getList : function() {        
      var setting = require('../router/routerSetting');   
      //連接routerSetting檔案
      var result = setting.getFisrtRouter( window.location.pathname,this.$router.options.routes)
      this.strMainPath = result.fristPath;
      this.showClass = result.routerItem.showClass;
      
      return result.routerItem.children !== undefined ? result.routerItem.children : []
    },
    pageChange : function(obj){      
      if(obj.currentTarget.getElementsByTagName('a').length > 0){
        if(obj.currentTarget.getElementsByTagName('a')[0].attributes.length > 0){
          this.$emit('subMenuToParent', obj.currentTarget.getElementsByTagName('a')[0].attributes[0].nodeValue)
        }
      }            
    },
    menuBind : function(obj , i){        
        var strmenu = ''
        var strPath = this.strMainPath
         if (this.expanded(obj.children, this.strurl) === 'true'){
            strmenu += '<ul class="collapse show" id="subTitle'+ i + '" style="margin: 0 0 0 20px">'
        }else {
            strmenu += '<ul class="collapse" id="subTitle'+ i + '" style="margin: 0 0 0 20px">'
        }   
        obj.children.forEach((p, n) => {
          if(p.internalUrl === undefined){                
              strmenu +=  '<li><a '+ (this.selectorPage(p.path) ? 'class="current-title"' : '') +' href="' + strPath +'/' + obj.path +'/' + p.path +'">' + p.name +'</a></li>'
          }
          else{
              strmenu +=  '<li><a href="'+ p.internalUrl + '" target="_blank">' + p.name +'</a></li>'
          }
          if(obj.children.length === n + 1){
            strmenu+= '</ul>'
          }
        })        
        return strmenu
    },
    expanded(menuList, currentUrl){
      var comp = currentUrl.split('/')[currentUrl.split('/').length - 1];
      var result = menuList.find(o=>o.path === comp);   
      return result === undefined ? 'false' : 'true'
    },
    selectorPage(sourcePage){
      if(sourcePage === this.strurl.split('/')[this.strurl.split('/').length - 1]){
        return true;
      }
      else{
        return false;
      }
    }
  }
}
</script>

<style>
[aria-expanded="false"] .fa-chevron-down {
  display: inline;
}
[aria-expanded="false"] .fa-chevron-up {
  display: none;
}
[aria-expanded="true"] .fa-chevron-down {
  display: none;
}
[aria-expanded="true"] .fa-chevron-up {
  display: inline;
}
</style>


// WEBPACK FOOTER //
// src/components/MenuListContent.vue